var _path, _circle, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoundIllustrationTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 202,
    viewBox: "0 0 124 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5295 138.11C33.631 141.271 77.7366 137.525 77.3468 97.2523C76.8595 46.9108 11.4278 115.306 63.8905 118.493C105.861 121.043 117.731 83.054 118.42 63.7408",
    stroke: "#4DFFFF",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "matrix(-1 0 0 1 81 0)",
    fill: "#4DFFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(-1 0 0 1 112 139)",
    fill: "#4DFFFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "matrix(-1 0 0 1 59 181)",
    fill: "#4DFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7562 6C19.4694 9.70408 28.1994 19.2066 25.5017 31.2551C22.4858 44.7245 -4.32407 48.0918 8.41047 72",
    stroke: "#4DFFFF",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundIllustrationTwo);
export default __webpack_public_path__ + "static/media/found_illustration_two.de1d711a3047472d3e6eacec2fc18deb.svg";
export { ForwardRef as ReactComponent };